module.exports = __webpack_public_path__ + "img/notification-active.28e1b5b3.svg";